export default "__VITE_ASSET__DIVXiCtj__"